import {Icon24BrowserBack, Icon28MessageOutline} from "@vkontakte/icons";
import Fancybox from "../assets/fancybox";

import axios from "axios";
import {
    Avatar,
    Cell, List,
    Chip,
    PanelHeader,
    PanelHeaderButton, RichCell, Header
} from "@vkontakte/vkui";
import React from "react";
import * as constants from "../assets/constants";
import {Icon28InfoCircleOutline} from '@vkontakte/icons';
import cartApi from "../api/CartApi";
import moment from "moment";
import {longDateTimeFormat} from "../assets/constants";
import BaseApi from "../api/BaseApi";


class MonitoringDocForm extends React.Component {

    constructor(props) {
        super(props);

    }

    getDoc = (id) => {

        let body = new FormData()

        body.append('id', id)

        axios.post(this.props.base_url + '?app=MonitoringDocs&act=showOne', body,
            {
                withCredentials: true

            }
        ).then((response) => {

            if (response.data.doc_data) {
                this.props.select_doc(response.data)
            }


        })

    }

    render() {
        let images_url = this.props.base_url.replace("frontend/", '');
        moment.locale('ru')
        return (this.props.current_doc ? [
            <PanelHeader style={{whiteSpace: "pre-line"}} before={this.props.show_back && this.props.hideDoc ?
                <PanelHeaderButton onClick={this.props.hideDoc}
                                   key="cmd_back_doc"><Icon24BrowserBack/></PanelHeaderButton> : ''}>

                {this.props.current_doc.meta_data.title}
            </PanelHeader>,
            <List>
                <Header
                    mode="primary">
                    Документ мониторинг
                </Header>
                <Cell before={<Icon28InfoCircleOutline/>} after={this.props.current_doc.doc_data.NomerDocKIS}><Chip
                    removable={false}>Документ</Chip></Cell>
                <Cell before={<Icon28InfoCircleOutline/>} after={this.props.current_doc.doc_data.meta.Дата}><Chip
                    removable={false}>Дата</Chip></Cell>
                {this.props.current_doc.doc_data.meta.Комментарий ? <Cell before={<Icon28MessageOutline/>}
                                                                          after={this.props.current_doc.doc_data.meta.Комментарий}><Chip
                    removable={false}>Комментарий</Chip></Cell> : ''}
                <Cell before={<Icon28InfoCircleOutline/>} after={this.props.current_doc.doc_data['status_name']}><Chip
                    removable={false}>Статус</Chip></Cell>

            </List>,

            <Header
                mode="primary">
                Состав документа
                / {this.props.current_doc.doc_items.length} {constants.inducement(this.props.current_doc.doc_items.length, 'позиция', 'позиции', 'позиций')}
            </Header>,
            (
                <List><Fancybox>
                    {this.props.current_doc.doc_items.length > 0 ?
                        [
                            this.props.current_doc.doc_items.map((item, index) => (
                                    [<RichCell multiline={true}
                                               before={[<a data-fancybox={'galleryCart' + item.id}
                                                           href={images_url + item.image.replace(images_url, '')}>
                                                   {<Avatar mode="image" style={{borderRadius: '5%'}} size={82}
                                                            src={images_url + item.thumb}/>}</a>

                                               ]}
                                               caption={moment(item.date_time).format(longDateTimeFormat)}


                                    >
                                        <span onClick={() => BaseApi.openProductSearch(item.name)}>{item.name}</span>
                                    </RichCell>]
                                )
                            )
                        ] : <Cell>Корзина пуста</Cell>}
                </Fancybox>
                </List>)


        ] : '')

    }
}

export default MonitoringDocForm